module.exports = __webpack_public_path__ + "a7f6cca748ce66fe96fd1e06ce548076.pdf";